import { Pipe, PipeTransform } from "@angular/core";
import { WhiteLabelService } from "app/core/white-label/white-label.service";

@Pipe({
  name: "letterCase",
  standalone: true,
})
export class LetterCasePipe implements PipeTransform {
  constructor(private whiteLabelService: WhiteLabelService) {}

  public transform(value: string): string {
    const useUppercase: boolean = this.whiteLabelService.data?.useUppercase!;
    if (useUppercase) {
      return value?.toUpperCase();
    }

    return value;
  }
}
